"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRisks = createRisks;
const shared_1 = require("../../shared");
const createAlcohol_1 = require("./createAlcohol");
const createAllergiesAndSensitivities_1 = require("./createAllergiesAndSensitivities");
const createSmoking_1 = require("./createSmoking");
const messages = {
    risks: {
        id: "ktx.dashboard.risks",
        defaultMessage: "Kockázati tényezők"
    }
};
function createRisks(intl, options) {
    const alcohol = (0, createAlcohol_1.createAlcohol)(intl, options);
    const smoking = (0, createSmoking_1.createSmoking)(intl, options);
    const allergiesAndSensitivities = (0, createAllergiesAndSensitivities_1.createAllergiesAndSensitivities)(intl, options);
    const content = (0, shared_1.createGroupContent)([
        alcohol,
        smoking,
        ...allergiesAndSensitivities
    ]);
    return (0, shared_1.createGroup)(intl, { label: messages.risks, content });
}
